import * as React from 'react';
import { FormattedMessage } from 'react-intl';
import { formatPartialDate } from 'Utility/date';

import { Item } from '../../../../components/Grid';
import HistoryRowControls from '../../../../components/HistoryRowControls';
import HistoryRowListing from '../../../../components/HistoryRowListing';
import HistorySection from '../../../../components/HistorySection';
import DocumentCreationButton from '../../../../components/DocumentCreationButton';

const BloodPressure = ({ documents, startEdit }: IOwnProps): React.JSX.Element => {
  return (
    <HistorySection
      headerText={<FormattedMessage id={'clinicalstudy.bloodPressure'} />}
      newButton={
        <DocumentCreationButton
          name="bloodPressure"
          text={'clinicalstudy.newBloodPressure'}
          onClick={startEdit({}, 'bloodPressure')}
          width={15}
          height={3}
          fontSize={14}
          alternate={true}
        />
      }
    >
      <HistoryRowListing
        documents={documents}
        headers={
          <>
            <Item xs={2}>
              <FormattedMessage id={'general.date'} />
            </Item>
            <Item xs={2}>
              <FormattedMessage id={'clinicalstudy.bloodPressureSystolic'} />
            </Item>
            <Item xs={2}>
              <FormattedMessage id={'clinicalstudy.bloodPressureDiastolic'} />
            </Item>
            <Item xs={6} />
          </>
        }
        contentFormat={(d: IBloodPressure): React.JSX.Element => (
          <>
            <Item xs={2} style={{ fontWeight: '600' }}>
              {formatPartialDate(d.date ?? undefined)}
            </Item>
            <Item xs={2}>
              {d?.bloodPressureSystolic ? (
                <FormattedMessage id="clinicalstudy.bloodPressureUnit" values={{ n: d?.bloodPressureSystolic }} />
              ) : (
                '-'
              )}
            </Item>
            <Item xs={2}>
              {d?.bloodPressureDiastolic ? (
                <FormattedMessage id="clinicalstudy.bloodPressureUnit" values={{ n: d?.bloodPressureDiastolic }} />
              ) : (
                '-'
              )}
            </Item>
            <Item xs={3} />
            <Item xs={3}>
              <HistoryRowControls document={d} startEdit={startEdit} />
            </Item>
          </>
        )}
      />
    </HistorySection>
  );
};

interface IOwnProps {
  documents: IBloodPressure[];
  startEdit: (document: TAnyObject, name?: string) => (e: React.MouseEvent<Element, MouseEvent>) => void;
}

export default BloodPressure;
